import CircularProgress from '@mui/material/CircularProgress';

import { Alert } from '@mui/material';

import { useEffect, useState } from 'react';

import { Ads, useAds } from 'api/ads';

import { Box, Button, CustomBox, SLIDER_SETTINGS } from 'common';

import { AdsCard } from 'widgets/cards';
import Slider from 'react-slick';
import { useLanguage } from '../../context/LanguageContext';
import { adsLabels } from '../../locales/translations';


export const AdsComponent = () => {
    const settings = SLIDER_SETTINGS;
    const { language } = useLanguage();
    const buttonLabel = adsLabels.allAdsButton[language];
    const title = adsLabels.adsTitle[language];

    const [adsList, setAdsList] = useState<Ads[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const { onGetAllAds } = useAds();

    useEffect(() => {
        (async () => {
            try {
                const result = await onGetAllAds();
                if (result.success) {
                    const filteredAndSortedAds = result.data
                        .filter((ad: Ads) => ad.show) // Отображаем только объявления с show === true
                        .sort((a: Ads, b: Ads) =>
                            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                        );
                    setAdsList(filteredAndSortedAds);
                } else {
                    setError('Произошла ошибка при загрузке новостей');
                }
            } catch (error: any) {
                setError(error.message || 'Неизвестная ошибка');
            } finally {
                setLoading(false);
            }
        })();
    }, [onGetAllAds]);

    return (
        <>
            {adsList.length !== 0 ? (
                <CustomBox title={title}>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <CircularProgress />
                        </Box>
                    ) : error ? (
                        <Alert severity="error">{error}</Alert>
                    ) : (
                        <Slider {...settings}>
                            {adsList.map((adsItem) => (
                                <Box key={adsItem.id} sx={{ padding: 2 }}>
                                    <AdsCard adsItem={adsItem} />
                                </Box>
                            ))}
                        </Slider>
                    )}

                    <Box sx={{ paddingTop: 6, display: 'flex', justifyContent: 'center' }}>
                        <Button variant="contained" color="error" href="/ads">
                            {buttonLabel}
                        </Button>
                    </Box>
                </CustomBox>
            ) : (<></>)}
        </>


    );
};
